/**
 * Created by jpilz on 2/13/17.
 */
import $ from 'jquery';

export default class ssoUtil {

    constructor(context) {
        this.name = "ssoUtil";
        this.context = context;

        //Profile API
        this.api = "https://auth.blr.com";

        //axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
    }

    isAuthenticated() {

        //getPreferences
        console.log("ssoUtil: isAuthenticated");
        
        let url = this.api + '/account/IsAuthenticated';
        let callData = {AuthenticationSystem:"WA"};

         /**
         *      xhrFields: {
                    withCredentials: true
                 },
         */

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: "GET",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                 },
                data: callData
            })
            .done((data, textResponse, request) => {
                console.log("ssoUtil:isAuthenticated:Success:" + data);
                console.log(data);

                console.log(textResponse);
                resolve(data);
            })
            .fail((responseData, textStatus, errorThrown) => {

                console.log("ssoUtil:isAuthenticated:Error");
                console.log(responseData);
                console.log(textStatus);
                console.log(errorThrown);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling isAuthenticated"},"messageModel");

                resolve(responseData);
            });

        });

    }    

    login({username = "blrnpd",password = "smiley"}) {

        let url = this.api + '/account/Login';
        //let callData = JSON.stringify({"UserName":username, "AuthenticationSystem":"MB", "ApplicationId": this.context.ApplicationId, "Password":password});
        let callData = {"UserName":username, "AuthenticationSystem":"WA", "Password":password};

        console.log("callLoginData:");
        console.log("UserName:" + username);
        console.log("Password:" + password);


        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: "POST",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                 },
                data: callData
            })
              .done((responseData, textStatus, jqXHR) => {
                console.log("ssoUtil:login:Success:" + responseData);
                console.log(responseData);
                console.log(textStatus);
                console.log(jqXHR);

                resolve(responseData);
              })
              .fail((responseData, textStatus, errorThrown) => {
                console.log("ssoUtil:login:Error");
                    console.log(responseData);
                    console.log(textStatus);
                    console.log(errorThrown);
                    this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling login"},"messageModel");

                reject(errorThrown);
              });

        });



    } 

    handleLogin(data)
    {
        console.log("ssoUtil:handleLogin:");
        console.log(data.getResponseHeader('Content-Type'));
        //console.log(data.getResponseHeader('BLRUserId'));
        //console.log(data.getResponseHeader('ASPXAUTH'));
        //BLRUser,BLRUserId,.ASPXAUTH,.ASPXAUTH,WebAuthToken

        return;
    }


}




// WEBPACK FOOTER //
// ./src/objects/ssoUtil.js